"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var react_components_1 = require("@lws/react-components");

var TextAlign;

(function (TextAlign) {
  TextAlign["Left"] = "Left";
  TextAlign["Center"] = "Center";
})(TextAlign = exports.TextAlign || (exports.TextAlign = {}));

exports.TextComponent = function (_a) {
  var data = _a.data,
      alignment = _a.alignment;
  var text = data.richText('text');
  var isCentered = alignment === TextAlign.Center;
  return react_1["default"].createElement(components_1.Grid, null, react_1["default"].createElement(GridRow_1.GridRow, {
    columnVariate: true
  }, isCentered && react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 2
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 4,
    sm: 6,
    md: 8
  }, react_1["default"].createElement(react_components_1.FootnotesRichtextRenderer, {
    content: text,
    wrapper: components_1.Paragraph
  })), isCentered && react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 2
  })));
};